import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  About,
  Contact,
  Experience,
  Footer,
  Header,
  Nav,
  Portfolio,
  Services,
  Testimonials,
  Background,
 } from './components';
import i18n from './i18n';

const App = () => {
  const [navAnchor, setNavAnchor] = useState('');
  const [fullscreen, setFullscreen] = useState(false);
  const [themeMode, setThemeMode] = useState(false);
  const { t } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  }

  const handleFullscreen = () => {
    if (!fullscreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    setFullscreen(!fullscreen);
  }

  const handleThemeMode = () => {
    setThemeMode(!themeMode);

    if (!themeMode) {
      document.getElementById('root').classList.add('lightmode');
    } else {
      document.getElementById('root').classList.remove('lightmode');
    }
  }

  return (
    <main>
      <Background 
        themeMode={ themeMode }
      />
      <Header 
        t={ t }
      />
      <Nav
        changeLanguage={changeLanguage}
        navAnchor={ navAnchor }
        setNavAnchor={ setNavAnchor }
        fullscreen={ fullscreen }
        themeMode={ themeMode }
        setThemeMode={ setThemeMode }
        handleFullscreen={ handleFullscreen }
        handleThemeMode={ handleThemeMode }
        t={ t }
      />
      <About 
       t={ t }
      />
      <Experience 
       t={ t }
      />
      <Services 
       t={ t }
      />
      <Portfolio 
       t={ t }
      />
      <Testimonials 
       t={ t }
      />
      <Contact 
       t={ t }
      />
      <Footer 
       t={ t }
      />
    </main>
  )
}

export default App;